import { ITechnician } from '../../../../../app/entities/Technician'

export function getTechnicianByObjectId(technicianObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}`,
  }
}
export function getLocationByLocationId(locationObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationObjectId}`,
  }
}
export function getPicturesByIds(technicianIds: string[]) {
  return {
    method: 'GET',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/technicians/pictures?techObjectIds=${JSON.stringify(technicianIds)}`,
  }
}
export function editTech(body: any) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/technicians`,
    body,
  }
}
export function createTech(body: any) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians`,
    body,
  }
}
export function initializeTechnicianSchedule(technicianId: string) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianId}/initialize-schedule`,
  }
}
export function setTechToLocation(
  locationId: string | null,
  technicianId: string,
) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/technicians/${technicianId}`,
  }
}
export function uploadTechAvatar(technicianObjectId: string, image: FormData) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}/avatar`,
    body: image,
  }
}
export function determineEffectOfTechnicianUpdate(
  technicianObjectId: string,
  bumpToPendingRescheduling: boolean,
  newTechnicianMode?: Pick<
    ITechnician,
    'inactive' | 'acceptsDeliveries' | 'acceptsInstallations'
  >,
  newLocationObjectId?: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}/update/check`,
    body: {
      bumpToPendingRescheduling,
      newTechnicianMode,
      newLocationObjectId,
    },
  }
}
